module.exports = __webpack_public_path__ + "img/content-03@2x.4fcb0274.png";